module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-agency-filled-df443640c10825f4a375a117c3ffc31d.svg";